import TrophyResource from "../../resources/trophy-resource"

export const makeTrophyResource = (): TrophyResource => {
    return new TrophyResource()
}
